export enum ColorType {
  Blue = "Blue",
  Yellow = "Yellow",
  Orange = "Orange",
  Green = "Green",
  Red = "Red",
  Grey = "Grey",
}
